export default class TerceptAdapter {
  constructor(tech, ima) {
    this._tech = tech;
    this._ima = ima;
  }

  tech() {
    return this._tech;
  }

  ima() {
    return this._ima;
  }

  adEvents() {
    return [
      google.ima.AdEvent.Type.CLICK,
      google.ima.AdEvent.Type.STARTED,
      google.ima.AdEvent.Type.IMPRESSION,
      google.ima.AdEvent.Type.FIRST_QUARTILE,
      google.ima.AdEvent.Type.MIDPOINT,
      google.ima.AdEvent.Type.THIRD_QUARTILE,
      google.ima.AdEvent.Type.COMPLETE,
      google.ima.AdEvent.Type.SKIPPED,
    ]
  }

  bindAdsReady() {
    this.tech().on("adsready", this.bindAdEvents.bind(this));
  }

  bindAdEvents() {
    this.adEvents().forEach(adEvent => this.logEvent(adEvent));
  }

  logEvent(adEvent) {
    this.ima().addEventListener(adEvent, this.logTercept);
  }

  logTercept(adEvent) {
    window && window.tercept && window.tercept.logEvent && window.tercept.logEvent(adEvent);
  }
}